<app-header></app-header>
<ion-content
  [ngClass]="{'desktop': isDesktop, 'tablet': isTablet, 'mobile': isMobile, }"
>
  <div class="header-wrapper">
    <ion-grid>
      <ion-row>
        <ion-col size="8" class="header-column">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="isDesktop">
        <h1>{{'i18n.imageOrderingPage.imageOrdering' | translate}}</h1>
      </ion-row>
    </ion-grid>
  </div>

  <ion-grid>
    <div>
      <!-- STEP 1: CHOOSE FILE -->
      <app-image-ordering-choose-file
        *ngIf="!loading && !apiResp"
        [platformType]="platformService.platformType"
        [hasCameraAccess]="hasCameraAccess"
        [showButtons]="apiResp?.suggestions?.length < 1 && !loading"
        (cameraOptionEmitter)="takePhoto()"
        (uploadFileOptionEmitter)="browseImages()"
      >
      </app-image-ordering-choose-file>
      <!-- STEP 2: LOADING -->
      <app-image-ordering-loading
        *ngIf="loading && !apiResp"
        [platformType]="platformService.platformType"
      >
      </app-image-ordering-loading>
      <!-- STEP 3: RESPONSE -->
      <app-image-ordering-result
        *ngIf="!loading && apiResp"
        [apiResp]="apiResp"
        [imageOrderingResults]="imageOrderingResults"
        [platformType]="platformService.platformType"
        [showFileSizeError]="showFileSizeError"
        [showFileTypeError]="showFileTypeError"
        [hasCameraAccess]="hasCameraAccess"
        (navigateToCartEmitter)="navigateToCartPage()"
        (navigateToListsEmitter)="navigateToListsPage()"
        (cameraOptionEmitter)="takePhoto()"
        (uploadFileOptionEmitter)="browseImages()"
        [isNewFormatEnabled]="isNewFormatEnabled"
      >
      </app-image-ordering-result>
      <app-image-ordering-table
        *ngIf="!loading && apiResp"
        [imageOrderingResults]="imageOrderingResults"
        [platform]="platformService.platformType"
        (deleteProductEmitter)="handleDeleteProduct($event)"
        (quantityChangeEmitter)="handleChangeQuantity($event)"
      ></app-image-ordering-table>

      <!-- IMAGE PICKER -->
      <input
        #imageInput
        type="file"
        accept="image/*"
        (change)="onImageChange($event)"
        class="hidden"
      />
    </div>
  </ion-grid>
  <app-footer></app-footer>
</ion-content>
